import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CmsDateTimeService {
  constructor() {}

  static getHoursInMilliseconds(hours: number) {
    return hours * 3600000;
  }

  static getDaysInMilliseconds(days: number) {
    return CmsDateTimeService.getHoursInMilliseconds(days * 24);
  }
}
